var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "right-calender"
  }, [_c('div', {
    staticClass: "top-main-calender scrollow1"
  }, [_c('section', {
    staticClass: "sec-common"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_vm._m(0), _c('button', {
    staticClass: "btn btn-primarymike",
    on: {
      "click": function ($event) {
        return _vm.$modal.show('HRMAddEmergencyContactModal');
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16.551",
      "height": "16.551",
      "viewBox": "0 0 16.551 16.551"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon_ionic-ios-add",
      "data-name": "Icon ionic-ios-add",
      "d": "M23.547,15.772H17.708V9.933a.968.968,0,0,0-1.936,0v5.839H9.933a.968.968,0,0,0,0,1.936h5.839v5.839a.968.968,0,1,0,1.936,0V17.708h5.839a.968.968,0,1,0,0-1.936Z",
      "transform": "translate(-8.465 -8.465)",
      "fill": "#fff",
      "stroke": "#fff",
      "stroke-width": "1"
    }
  })]), _vm._v(" Add emergency notes ")])]), _c('vb-table', {
    staticClass: "emergency-contacts-table-width mt-5",
    attrs: {
      "tableDesign": 1
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h5', {
    staticClass: "commonth emp-ec-firsttd col-left"
  }, [_vm._v("Name")]), _c('h5', {
    staticClass: "commonth emp-ec-secondtd"
  }, [_vm._v("relationship")]), _c('h5', {
    staticClass: "commonth emp-ec-thirdtd"
  }, [_vm._v("phone")]), _c('h5', {
    staticClass: "commonth emp-ec-fourtd"
  }, [_vm._v("e-mail")]), _c('h5', {
    staticClass: "commonth emp-ec-fivetd"
  }, [_vm._v("Address")]), _c('h5', {
    staticClass: "task-th emp-ec-sixtd col-right"
  }, [_vm._v("Action")])]), _c('template', {
    slot: "body"
  }, [_c('tr', [_c('td', {
    staticClass: "emp-ec-firsttd"
  }, [_vm._v(" Kendel Jenner ")]), _c('td', {
    staticClass: "emp-ec-secondtd"
  }, [_vm._v(" Sister ")]), _c('td', {
    staticClass: "emp-ec-thirdtd"
  }, [_vm._v(" 441873740607 ")]), _c('td', {
    staticClass: "emp-ec-fourtd"
  }, [_vm._v(" jenner@duplex.com ")]), _c('td', {
    staticClass: "emp-ec-fivetd"
  }, [_vm._v(" Kabul"), _c('br'), _vm._v(" Asia"), _c('br'), _vm._v(" Kabul, 66000 ")]), _c('td', {
    staticClass: "emp-ec-sixtd"
  }, [_c('div', {
    staticClass: "d-flex justify-content-end commonTableMain"
  }, [_c('b-dropdown', {
    staticClass: "common-table-dd",
    attrs: {
      "no-caret": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('b-icon', {
          attrs: {
            "icon": "three-dots-vertical"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")])], 1)], 1)])])])], 2)], 1)]), _c('HRMAddEmergencyContactModal')], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h5', {
    staticClass: "emp-profile-heading"
  }, [_vm._v("Emergency contacts")])]);

}]

export { render, staticRenderFns }